import _ from 'lodash'
import React from 'react'
import { useHistory, useParams } from 'react-router-dom'
import axios from 'utils/axios/modules/pay'

const useSecure3dsHook = () => {
  const { contractId, transId } = useParams()
  const [errorMsg, setErrorMsg] = React.useState('')
  const [isProcessing, setIsProcessing] = React.useState(false)
  const [modalDisplay, setModalDisplay] = React.useState(false)
  const [isUpdateCreditCard, setIsUpdateCreditCard] = React.useState(false)
  const history = useHistory()

  React.useEffect(() => {
    const abortController = new AbortController()

    if (contractId && transId) {
      update3DSCreditCard(abortController.signal)
    }

    return () => {
      abortController.abort()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contractId, transId])

  const update3DSCreditCard = () => {
    setIsProcessing(true)
    axios
      .updateCreditCard(contractId, {
        key: transId,
      })
      .then((res) => {
        if (_.isEmpty(res.data.credit_card) && res.data.credit_card?.is_update) {
          setIsUpdateCreditCard(true)
        }
        setModalDisplay(true)
      })
      .catch((error) => {
        if (error && _.isArray(error) && _.isString(error[0])) {
          setErrorMsg(error.join('\n'))
        }
      })
      .finally(() => {
        setIsProcessing(false)
      })
  }

  const closeModal = () => {
    setModalDisplay(false)
    setIsUpdateCreditCard(false)
    history.replace(`/service/${contractId}`)
  }

  const redirectDetailContract = () => {
    history.replace(`/service/${contractId}`)
  }

  const redirectPayEdit = () => {
    history.replace(`/pay/${contractId}/edit`)
  }

  return {
    transId,
    contractId,
    update3DSCreditCard,
    errorMsg,
    setErrorMsg,
    isUpdateCreditCard,
    setIsUpdateCreditCard,
    isProcessing,
    modalDisplay,
    closeModal,
    redirectDetailContract,
    redirectPayEdit,
  }
}

export default useSecure3dsHook
